import { render } from "./appointment-medications.vue?vue&type=template&id=2d8fc29c"
import script from "./appointment-medications.vue?vue&type=script&lang=js"
export * from "./appointment-medications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__